import React from 'react';

import { WorkInProgressView } from '../WorkInProgressView';

export const Week = () => <WorkInProgressView />;
